import { defineMessages } from 'react-intl';

export default defineMessages({
  websiteUrlScopeLabel: 'Website URLs',
  stagingUrlSuffix: 'Testing',
});
